import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ScoreModalComponent } from '../../../modals/score-modal/score-modal.component';

import { UserMenuDataService } from '../../../services/menu.service';

import *  as Classes from '../../../classes/models.classes'

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-trending-topics',
    templateUrl: './trending-topics.component.html',
    styleUrls: ['./trending-topics.component.css']
})
export class TrendingTopicsComponent implements OnInit {
    //@Input() postData: any;
    @Input() UserID: number;

    @Output() hasData = new EventEmitter<boolean>();

    //@Output() reactionsUpdated = new EventEmitter<any>();

    trendingTopics: any[] = [];

    private searchSubject = new Subject<string>();

    constructor(
        private userMenuDataService: UserMenuDataService,
        private router: Router,
        private modalService: NgbModal,
        private http: HttpClient
    ) {
    }

    ngOnInit() {
        this.loadTrendingTopics();
    }

    loadTrendingTopics() {
        this.userMenuDataService.getTrendingTopics(this.UserID).subscribe(
            (topics) => {
                this.trendingTopics = topics;
                this.hasData.emit(topics.length > 0);
            },
            (error) => {
                console.error('Error loading suggested users:', error);
                this.hasData.emit(false);
            }
        );
    } 

}
